export function getFormattedTotalAmount(value, isTotalAmountFieldFocused = false) {
    if (typeof value !== 'number' || isNaN(value)) {
        return null;
    }
    return isTotalAmountFieldFocused ? value.toString() : `${value.toLocaleString()} kg`;
}
